import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-poll-layout',
  templateUrl: './poll-layout.component.html',
  styleUrls: ['./poll-layout.component.css']
})
export class PollLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
